import { type ActorRefFromLogic } from "xstate";

import { storeId } from "@moment/api-collab";

import { type AuthenticationMachine } from "../../state/machines/authentication";
import { RebootContext, type RebootInstance, RebootStore } from "./types";

export * from "./RebootSubscriber";
export * from "./types";

export const PROD_REBOOT_URL = "https://axibtdbnwf7.prod1.rbt.cloud:9991";
export const STAGING_REBOOT_URL = "https://acczhr2wb7t.prod1.rbt.cloud:9991";

export const rebootStoreRef = ({
	workspaceName,
	documentId,
	authenticationActorRef,
}: {
	workspaceName: string;
	documentId: string;
	authenticationActorRef: ActorRefFromLogic<AuthenticationMachine>;
}): RebootInstance => {
	const getBearerToken = async () => {
		const authCtx = authenticationActorRef.getSnapshot().context;
		return authCtx.authnStatus === "authenticated"
			? authCtx.getAccessTokenSilently()
			: undefined;
	};
	return {
		store: RebootStore.ref(storeId(workspaceName, documentId)),
		context: new RebootContext({ url: getBaseRebootUrl(), bearerToken: getBearerToken }),
	};
};

export const isRunningInIframe = () => {
	if (typeof window === "undefined") {
		return false;
	}

	return window.parent !== window.self;
};

// Reboot should run only in client side code (tauri or web)
// Set REBOOT_URL=http://localhost:9991 to connect to a local reboot server
// Set ENABLE_REBOOT to anything else to disable reboot entirely from the local runtime
//  * TODO: handle when the desktop app is offline
export const getBaseRebootUrl = (): string => {
	if (process.env["REBOOT_URL"] !== undefined && process.env["ENABLE_REBOOT"] !== "") {
		return process.env["REBOOT_URL"] ?? "";
	}

	if (isRunningInIframe()) {
		// HACK!!! for some reason iframe does not get PROCESS ENV!!!
		const hostname = window.location.hostname;
		if (hostname.includes("iframe.moment.dev")) {
			return PROD_REBOOT_URL;
		}
		return STAGING_REBOOT_URL;
	}

	switch (process.env["APP_ENV"]) {
		case "local":
			return STAGING_REBOOT_URL;
		case "staging":
			return STAGING_REBOOT_URL;
		case "production":
			return PROD_REBOOT_URL;
		default:
			console.warn(`WARNING: no reboot url defined, not connecting to reboot`);
			return ""; // default to nothing for unknown env
	}
};
